import React from 'react'
import { useNavigate } from 'react-router-dom'
import './ItemList.css'
import { PageProperties } from '../types'
import { useState } from 'react'
import { useEffect } from 'react'
import { formatDate } from '../utils'
import { separator } from '../App'
import { listAvailableSpaces } from '../api-utils'
import Spinner from '../components/Spinner'

// const separator = <hr style={{ background: "#232043", height: 1.5 }} />

const getItemList = (items: Array<any>, navigate: (id: string) => void) => (
  <div style={{ maxWidth: "90%" }}>
    {
      items?.map((item) => {
        // const imageDiv = (<div className="project-img has-text-centered  is-flex-direction-column is-align-items-center is-align-self-center">
        //   <div className="is-size-7 is-align-items-center is-align-self-center">{item.image?.legend}</div>
        //   <img
        //     className="project-img-file"
        //     width={item.image?.width ? item.image.width : "600"}
        //     alt={item.title}
        //     src={require(`../site/images/${item.image?.uri}`)}
        //     onClick={() => window.open(item.image?.link)}
        //   />
        // </div>)

        const descriptionDiv = (
          <div className="project-desc center">
            <div className="forceBlack is-size-4">
              {/* <div>Parking space<strong style={{ fontFamily: "monospace" }}>{` ${item.space_unit}`}</strong></div> */}
              <span className="is-capitalized" style={{ fontWeight: 500 }}>{item.type.replaceAll("-gated", " ")} Space</span>
              <div className="is-size-6 is-italic" style={{ fontFamily: "monospace" }}>{`${item.width}ft x ${item.length}ft`}</div>
              <div className="is-size-6 is-italic" style={{ fontFamily: "monospace" }}>{item.type.includes("gated") ? "Gated" : "Non-Gated"}</div>
              <div className="is-size-6" style={{ fontFamily: "monospace" }}>{item.status === "move-out-scheduled" && item.move_out_date
                ?
                `Available ${formatDate(new Date(item.move_out_date), 'numeric')}`
                :
                `Available Now`
              }
              <div className="is-size-6" style={{ fontFamily: "monospace" }}>{`$${item.monthly_rate}.00 `} / month</div>
              </div>
            </div>
          </div>
        )

        return (
          <div className="project" key={item.id}>
            {/* {imageDiv} */}
            {descriptionDiv}
            {/* {<hr className="bigHR" />}
            <br /> */}
            <button
              style={{ background: '#232043', color: 'yellow' }}
              onClick={() => {
                console.log("Reserving spot ", item.id)
                navigate(`/storage-form?id=${item.id}`)
              }}
            >
              <div className="is-size-5" style={{ fontFamily: "monospace" }}>Reserve Now</div>
            </button>
          </div>
        )
      })
    }
  </div >
)

const ItemList = ({ page }: PageProperties) => {
  const [items, setItems] = useState<any[]>([])
  const [hasLoaded, setHasLoaded] = useState<boolean | undefined>();
  const navigate = useNavigate();

  // Fetch available spaces using Netlify function
  useEffect(() => {
    if (items && items.length === 0 && !hasLoaded) {
      setHasLoaded(false);

      const fetchData = async () => {
        const response = await listAvailableSpaces();
        if (response.success && response.spaces && response.spaces.length > 0) {
          setItems(response.spaces);
        }
        setHasLoaded(true);
      }

      fetchData()
        .catch((error: Error) => {
          console.error(" Oh NO!", error);
          setHasLoaded(true);
        })
    }
  }, [items, setItems, hasLoaded])

  return (
    <div
      style={{
        padding: "8%",
        minHeight: "64vh",
        background: `linear-gradient(${page.gradient?.direction}, ${page.gradient?.first}, ${page.gradient?.second})`
      }}>
      <div className="title forceBlack boldFontFamily">
        {hasLoaded && page.title}
      </div>
      <div className="subtitle forceBlack">
        {!hasLoaded ? "...loading available spaces" : items && items?.length > 0 ? page.subtitle : "Text or call us at (614) 699-2495 if you're not seeing any available spaces below ..."}
      </div>
      {!hasLoaded ? <Spinner /> : (
        items?.length ? (
          <>{separator}{getItemList(items, navigate)}</>
        ) : null
      )}
    </div>
  )
}

export default ItemList